import { useContext } from "react";
import SurveyQuestion from "../survey-question";

import SurveyDimensionDescription from "./description";
import CustomButton from "../custom-button";

import { SurveyContext } from "../../providers/survey";

import * as Dimensions from "../../utils/survey/dimensions";

const SurveyDimension = ({
  dimensionIndex,
  dimensionName,
  dimensionDescription,
  singleRowQuestions,
  questions = [],
  optional = false,
  showOptionalMessage = false,
  clearable = false,
}) => {
  const { answers, clearAnswersFromDimension } = useContext(SurveyContext);
  const clearAnswersIsVisible =
    clearable && Dimensions.dimensionHasAnswers(answers, dimensionIndex);

  const renderedQuestions = questions.map((question, questionIndex) => {
    return (
      <div
        key={`survey-question-${dimensionIndex}-${questionIndex}`}
        className={
          singleRowQuestions &&
          Dimensions.findInSingleRowQuestions(questionIndex, singleRowQuestions)
            ? "col-sm"
            : ""
        }
      >
        <SurveyQuestion
          key={`survey-question-${dimensionIndex}-${questionIndex}`}
          dimensionIndex={dimensionIndex}
          questionIndex={questionIndex}
          question={question}
        />
      </div>
    );
  });

  const groupedQuestions = singleRowQuestions
    ? Dimensions.orderQuestionsByGroups(renderedQuestions, singleRowQuestions)
    : renderedQuestions;

  const onClickClearDimension = () => clearAnswersFromDimension(dimensionIndex);

  return (
    <div className="animated--fade-in">
      <div className="d-flex flex-row align-items-center justify-content-between">
        <h2 className="pt-2 pl-1 text-primary">{dimensionName}</h2>
        {clearAnswersIsVisible && (
          <div className="float-right">
            <CustomButton text="Borrar respuestas" onClick={onClickClearDimension} />
          </div>
        )}
      </div>
      {dimensionDescription && (
        <SurveyDimensionDescription descriptionData={dimensionDescription} />
      )}
      {optional && showOptionalMessage && (
        <div className="card mb-2">
          <div className="card-header green">
            Esta sección es opcional. Puedes dejarla en blanco si así lo deseas.
          </div>
        </div>
      )}
      {groupedQuestions.map((group, groupIndex) =>
        Array.isArray(group) ? (
          <div key={`survey-dimension-${dimensionIndex}-group-${groupIndex}`} className="row">
            {group}
          </div>
        ) : (
          group
        )
      )}
    </div>
  );
};

export default SurveyDimension;
